import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../../contexts/AuthContext";

const Redirect = () => {
  const navigate = useNavigate();

  const { userLoggedData } = useContext(AuthContext);

  useEffect(() => {
    if (!userLoggedData) {
      navigate("/login");
      return;
    }

    const role = userLoggedData.role?.toUpperCase?.() || "";
    const clubs = Array.isArray(userLoggedData?.clubs)
      ? userLoggedData.clubs
      : [];
    const selectedClubId = userLoggedData?.selectedClubId ?? null;

    if (role === "SUPER_ADMIN") {
      navigate("/super-admin/clubs");
      return;
    }

    if (clubs.length === 0) {
      if (role === "ADMIN") {
        navigate("/private/admin/dashboard");
        return;
      }
      if (role === "PLAYER" || role === "USER") {
        navigate("/private/user/home");
        return;
      }
      navigate("/user/error");
      return;
    }

    const clubId = selectedClubId || clubs?.[0]?.id || null;
    if (!clubId) {
      navigate("/user/error");
      return;
    }

    if (role === "ADMIN") {
      navigate(`/c/${clubId}/admin/dashboard`);
      return;
    }

    if (role === "PLAYER" || role === "USER") {
      navigate(`/c/${clubId}/user/home`);
      return;
    }

    navigate("/user/error");
  }, [navigate, userLoggedData]);

  return <div>Redirecionando...</div>;
};

export default Redirect;
